(() => {
  if (window.ftShopStatusInitialized) return;
  window.ftShopStatusInitialized = true;

  const freeShipping = 5000;
  let requestNumber = 0;

  const money = (cents, currency = 'EUR') =>
    new Intl.NumberFormat('nl-NL', { style: 'currency', currency }).format(cents / 100);

  async function updateStatus() {
    const id = ++requestNumber;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('Cart ophalen mislukt');

      const cart = await response.json();
      if (id !== requestNumber) return;

      const cents = cart.total_price || 0;
      const count = cart.item_count || 0;
      const currency = cart.currency || 'EUR';
      const message = cents < freeShipping
        ? `Nog ${money(freeShipping - cents, currency)} tot gratis verzending!`
        : 'Gratis verzending verdiend! 🎉';
      const percentage = Math.min(Math.max(cents, 0), freeShipping) / freeShipping * 100;

      document.querySelectorAll('[data-ft-total]').forEach(el => {
        el.textContent = money(cents, currency);
      });
      document.querySelectorAll('[data-ft-count]').forEach(el => {
        el.textContent = count;
      });
      document.querySelectorAll('[data-ft-message]').forEach(el => {
        el.textContent = message;
      });
      document.querySelectorAll('[data-ft-fill]').forEach(el => {
        el.style.width = `${percentage}%`;
      });
      document.querySelectorAll('[data-ft-progress]').forEach(el => {
        el.setAttribute('aria-valuenow', String(Math.min(cents / 100, 50)));
      });
    } catch (error) {
      console.warn('FunTargets winkelwagenstatus:', error);
    }
  }

  document.addEventListener('shopify:cart:lines-update', event => {
    if (event.promise) {
      Promise.resolve(event.promise).then(updateStatus).catch(() => {});
    } else {
      updateStatus();
    }
  });
  document.addEventListener('shopify:cart:discount-update', event => {
    if (event.promise) {
      Promise.resolve(event.promise).then(updateStatus).catch(() => {});
    } else {
      updateStatus();
    }
  });
  window.addEventListener('pageshow', updateStatus);
  updateStatus();
})();
